import { DateRangeType } from '@fluentui/date-time-utilities/lib/dateValues/dateValues';
import { logUsage } from 'owa-analytics';
import { ControlIcons } from 'owa-control-icons';
import { DisplayOption, FilterableMenuItem, FilterableMenuItemArgs } from 'owa-filterable-menu';
import { getSurfaceStore } from 'owa-calendar-surface-surface-store';
import {
    goToNextSurfaceDateRange,
    goToPreviousSurfaceDateRange,
} from 'owa-calendar-module-commanding';
import { getPreviousLabel, getNextLabel } from '../../utils/getSurfaceNavigationStrings';

export function getSurfaceNavigationMenuItems() {
    const currentDateRangeType = getSurfaceStore().dateRangeType;
    const previousLabel = getPreviousLabel(currentDateRangeType);
    const nextLabel = getNextLabel(currentDateRangeType);

    const onPrevious = () => {
        logUsage('SurfaceCommandBar_Previous', {
            currentDateRangeType: currentDateRangeType,
        });
        goToPreviousSurfaceDateRange();
    };

    const onNext = () => {
        logUsage('SurfaceCommandBar_Next', {
            currentDateRangeType: currentDateRangeType,
        });
        goToNextSurfaceDateRange();
    };

    const isMonthDateRange = currentDateRangeType === DateRangeType.Month;

    return [
        new FilterableMenuItem({
            [FilterableMenuItemArgs.icon]: isMonthDateRange ? ControlIcons.Up : ControlIcons.Back,
            [FilterableMenuItemArgs.onClick]: onPrevious,
            [FilterableMenuItemArgs.displayOption]: DisplayOption.Left,
            [FilterableMenuItemArgs.ariaLabel]: previousLabel,
            [FilterableMenuItemArgs.title]: previousLabel,
            [FilterableMenuItemArgs.className]: 'flipForRtl',
        }),
        new FilterableMenuItem({
            [FilterableMenuItemArgs.icon]: isMonthDateRange
                ? ControlIcons.Down
                : ControlIcons.Forward,
            [FilterableMenuItemArgs.onClick]: onNext,
            [FilterableMenuItemArgs.displayOption]: DisplayOption.Left,
            [FilterableMenuItemArgs.ariaLabel]: nextLabel,
            [FilterableMenuItemArgs.title]: nextLabel,
            [FilterableMenuItemArgs.className]: 'flipForRtl',
        }),
    ];
}
